export enum CompetitorAnalysisChannel {
  PARTNERSCORE = 'partnerscore',
  CSATSCORE = 'csatscore',
  CESSCORE = 'cesscore',
  NPSSCORE = 'npsscore',
}

export interface CompetitorAnalysisChannelConfig {
  label: string;
  averageScore: number | string;
  changeScore: number | string;
  link: string;
  channel: CompetitorAnalysisChannel;
  tagline: string;
  normalizedScore?: string;
}
